import { jsx as _jsx } from "react/jsx-runtime";
import { SnackbarProvider } from "notistack";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router";
import { ErrorProvider, Layout, TrackProvider } from "./index.js";
export const AppWrapper = ({ theme, i18n, ...props }) => (_jsx(TrackProvider, { children: _jsx(Layout, { theme: theme, children: _jsx(BrowserRouter, { children: _jsx(I18nextProvider, { i18n: i18n, children: _jsx(ErrorProvider, { children: _jsx(SnackbarProvider, { ...props }) }) }) }) }) }));
//# sourceMappingURL=AppWrapper.js.map